/*
 * @Author:
 * @LastEditTime: 2022-06-15 09:36:43
 * @Description:
 */
import To from 'await-to-js'
import Callback from '@/services/Callback'
import qs from 'qs'
import { wizStandardInstance } from './instance'

export default class constructionManage {
  static async askPlanList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Activity/activity?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async addNewPlan(payload) {
    const [err, res] = await To(
      wizStandardInstance.put(`/api/Activity/activity?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async editwPlanName(payload) {
    const [err, res] = await To(
      wizStandardInstance.patch(`/api/Activity/activity?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async deletePlan(payload) {
    const [err, res] = await To(wizStandardInstance.delete('/api/Activity/activity', payload))
    return Callback(err, res)
  }
  static async uploadExcel(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        `/api/Activity/activity_import_excel?${qs.stringify(payload.query)}`,
        payload.formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      )
    )
    return Callback(err, res)
  }
  // 新版导入接口
  static async newUploadExcel(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        `/api/Activity/activity_import_excel?${qs.stringify(payload.query)}`,
        payload.formData
      )
    )
    return Callback(err, res)
  }
  // 下载模板
  static async getPlanTemplate() {
    const [err, res] = await To(
      wizStandardInstance.get('/api/Activity/activity_import_excel/template')
    )
    return Callback(err, res)
  }
  static async getProgress(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/tag/query_progress_bar/${payload.fileId}`)
    )
    return Callback(err, res)
  }
  static async downloadPlan(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Activity/activity_export_excel/${payload.id}`)
    )
    return Callback(err, res)
  }
}
